var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "finance-box" },
    [
      _vm.reload
        ? _c(
            "keep-alive",
            [
              _c(_vm.curComp, {
                tag: "component",
                attrs: { params: _vm.curParams },
                on: {
                  "update:params": function($event) {
                    _vm.curParams = $event
                  },
                  changeComp: _vm.changeComp,
                  goBack: _vm.goBack
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cfd7dda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfd7dda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/circulation/gold-financing/gold-financing.vue
// module id = X9fl
// module chunks = 1